class Transition {
  // ---------------------------------------------------------------------------
  // --	Transition
  // ---------------------------------------------------------------------------

  constructor() {
    this.isInit = false;
    this.isLock = false;
  }

  /**
   * 初期化
   */
  init() {
    //フラグ
    this.isInit = true;

    //DOM参照
    this.$elm = document.querySelector(".c-transition");
    this.$mark = this.$elm.querySelector(".c-transition__mark");
  }

  /**
   * 表示
   */
  show(href) {
    if (!href) return;

    //初期化されていない場合はそのまま遷移
    if (!this.isInit || !(href.length > 2 && href.charAt(0) == "/")) {
      location.href = href;
      return;
    }

    //ロック
    this.isLock = true;

    //全体を表示
    gsap.set(this.$elm, { alpha: 0 });
    gsap.to(this.$elm, {
      duration: 0.3,
      alpha: 1,
      ease: "none",
      onStart: () => {
        this.$elm.style.display = "flex";
      },
    });

    //マーク表示
    gsap.set(this.$mark, { alpha: 0 });
    gsap.to(this.$mark, {
      duration: 0.3,
      delay: 0.5,
      alpha: 1,
      ease: "none",
    });
    gsap.to(this.$mark, {
      duration: 0.3,
      delay: 1.3,
      alpha: 0,
      ease: "none",
      onComplete: () => {
        location.href = href;
      },
    });
  }

  /**
   * 非表示
   */
  hide() {
    gsap.to(this.$elm, {
      duration: 0.5,
      alpha: 0,
      ease: "none",
      onComplete: () => {
        this.isLock = false;
        this.$elm.style.display = "none";
      },
    });
  }

  // ---------------------------------------------------------------------------
}

export default new Transition();
